import { render } from "./ExpandButton.vue?vue&type=template&id=0787883a&scoped=true"
import script from "./ExpandButton.vue?vue&type=script&lang=js"
export * from "./ExpandButton.vue?vue&type=script&lang=js"

import "./ExpandButton.vue?vue&type=style&index=0&id=0787883a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0787883a"]])

export default __exports__